import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Row, Col, Table } from 'react-bootstrap';
import PropTypes from "prop-types";
import InputText from '../../../../../components/modalComponents/InputText';
import InputSelect from '../../../../../components/modalComponents/InputSelect';
import GenericModal from '../../../../../components/modal/GenericModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PrimaryActionButtonForModal } from '../../../styledComponents/styledComponents';
import { faEdit } from '@fortawesome/free-regular-svg-icons/faEdit';
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash';
import {
    cuadroRequerimientosGetAllCursosAPI,
    cuadroRequerimientosGetDataToEditPlanCurricularAPI,
    cuadroRequerimientosGetRelatedDataTypeWithDescripcionAPI,
    cuadroRequerimientosListarPlanesCurricularesAPI,
    cuadroRequerimientosRegistrarPlanCurricularAPI,
    cuadroRequerimientosEditarPlanCurricularAPI,
    cuadroRequerimientosEliminarPlanCurricularAPI
} from '../../../../../consumers/backendApisUrls';
import { useManageGetRequest } from '../../../../../hooks/useManageGetRequest/useManageGetRequest';
import { useManagePostRequest } from '../../../../../hooks/useManagePostRequest/useManagePostRequest';
import { ID_TIPO_NIVEL_NIVEL } from '../../../../../constants/hardCodedConstants';
import ModalForm from "../../../../../components/modalComponents/ModalForm";
import {useSubmitForm} from "../../../../../hooks/useSubmitForm/useSubmitForm";
import {clearAllInputValidationMessages} from "../../../../../validations/FormValidatorUtils";
import { v4 as uuidv4 } from 'uuid';

const Title = styled.div`
    font-weight: 600;
    font-size: 13px;
    width: 100%;
`;

const Styles = styled.div`
  .header-title {
    background-color: rgb(51, 124, 184); 
    color: white;
    padding: 10px 20px;
    border-radius: 10px 10px 0 0;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .sidebar-list {
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 10px;
    overflow-y: auto;
    max-height: 500px;
  }

  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px;
    border-bottom: 1px solid #eee;
    cursor: pointer;
    transition: background 0.2s;
    font-family: GothamLight;
    font-size: 14px;

    &:hover, &.active {
      background-color: #e9ecef;
    }

    &:last-child {
      border-bottom: none;
    }

    .actions {
      display: flex;
      gap: 1px;
    }
  }

  .table-container {
    display: block;
    width: 100%;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: auto;
    height: 27vh;
    border: 1px solid #dee2e6;
  }

  .custom-table {
    table-layout: fixed;
    text-align: center;
    width: 100%;
    margin-bottom: 0;
    
    th {
      vertical-align: middle;
      color: #333;
      white-space: nowrap;
      position: sticky;
      top: 0;
      background-color: #fff;
    }

    .bg-orange { background-color: #ffccbc; }
    .bg-blue { background-color: #b3e5fc; }
    .bg-green { background-color: #c8e6c9; }
    
    td {
        vertical-align: middle !important;
        border: 1px solid #dee2e6;
    }
  }

  .info-plan-curricular {
  }

  .action-icon {
    cursor: pointer;
    
    &:hover {
      color: #1890ff;
    }
  }

  @media (max-width: 992px) {
    .table {
      display: block;
    }
    .egssth .description {
      border: 0 !important;
    }
  }
`;

const ConfirmModalStyle = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;

    .modalHeader {
        background-color: #0064a7;
        .title {
            color: white;
            p {
                margin: 0;
            }
        }
        .icon {
            color: white;
        }
    }
`;

export const KEYS = {
    IdNivel: "IdNivel",
    Nombre: "Nombre",
};

const ConfigPlanCurricular = ({ showModal, title }) => {
    const SECTION_NAME = "";
    const [hidePlanCreate, setHidePlanCreate] = useState(false);

    const [plans, setPlans] = useState([]);
    const [niveles, setNiveles] = useState([]);
    const [cursos, setCursos] = useState([]);
    const [cursosCurrent, setCursosCurrent] = useState([]);

    const [selectedPlan, setSelectedPlan] = useState(null);
    const [formName, setFormName] = useState('');

    const [selectedNivel, setSelectedNivel] = useState(null);

    const [executeManageGet] = useManageGetRequest();
    const [executeManagePostRequest] = useManagePostRequest();

    const [specialties, setSpecialties] = useState([]);
    const [grades, setGrades] = useState([]);
    const [gridValues, setGridValues] = useState({});

    const [editMode, setEditMode] = useState(false);
    const [showSaveInfo, setShowSaveInfo] = useState(false);

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitForm] = useSubmitForm();

    const handleSelectPlan = (plan) => {
        resetFormTable();
        refetchPlanToEdit(plan);
        setShowSaveInfo(false);
        setEditMode(false);
        clearAllInputValidationMessages(Object.values(KEYS), SECTION_NAME);
    };

    const handleEditPlan = (plan) => {
        resetFormTable();
        refetchPlanToEdit(plan);
        setShowSaveInfo(true);
        setEditMode(true);
        clearAllInputValidationMessages(Object.values(KEYS), SECTION_NAME);
    };

    const refetchPlanToEdit = (plan) => {
        const api = cuadroRequerimientosGetDataToEditPlanCurricularAPI(plan?.IdPlanCurricular ?? 0);
        executeManageGet(api, (res) => {
            const data = res?.data;
            setSelectedPlan(data ?? null);
            setFormName(data?.Nombre ?? '');

            setSelectedNivel({ value: data?.IdNivel ?? 0, label: data?.Nivel ?? '' } ?? null);

            refetchGradesCurricular(data?.IdNivel ?? 0);

            if (data?.Celdas) {
                const newGridValues = {};
                const newSpecialties = [];
                const addedSpecialtyIds = new Set();

                const celdasSort = [...data.Celdas].sort((a, b) => a.Curso.localeCompare(b.Curso));

                celdasSort.forEach(celda => {
                    const { IdCurso, Curso, IdGrado, NroHoras } = celda;

                    if (!addedSpecialtyIds.has(IdCurso)) {
                        addedSpecialtyIds.add(IdCurso);
                        newSpecialties.push({ value: IdCurso, label: Curso });
                        newGridValues[IdCurso] = {};
                    }

                    newGridValues[IdCurso][IdGrado] = NroHoras;
                });

                const cursosCurrent = cursos.filter((curso) => !addedSpecialtyIds.has(curso.value));
                setCursosCurrent(cursosCurrent);
                setSpecialties(newSpecialties);
                setGridValues(newGridValues);
            } else {
                setSpecialties([]);
                setGridValues({});
            }
        }, false);
    };

    const handleNewPlan = (e) => {
        e && e.preventDefault();
        resetFormTable();
        setShowSaveInfo(true);
        setEditMode(true);
        clearAllInputValidationMessages(Object.values(KEYS), SECTION_NAME);
    };

    const handleClearAll = (e) => {
        e && e.preventDefault();;
        setShowConfirmModal(true);
    };

    const confirmClearAll = (e) => {
        e && e.preventDefault();
        setSelectedNivel(null);
        resetTable();
        setShowSaveInfo(true);
        setShowConfirmModal(false);
    };

    const closeConfirmModal = (e) => {
        e && e.preventDefault();
        setShowConfirmModal(false);
    };

    const handleSavePlan = async (e) => {
        e && e.preventDefault();
        const payload = {
            Nombre: formName?.trim() ?? '',
            Celdas: [],
            IdNivel: selectedNivel?.value ?? 0
        };

        if (selectedPlan) {
            payload.IdPlanCurricular = selectedPlan.IdPlanCurricular;
        }

        const celdas = [];
        Object.keys(gridValues).forEach(specId => {
            const gradeValues = gridValues[specId];
            Object.keys(gradeValues).forEach(gradeId => {
                celdas.push({
                    IdCurso: Number(specId ?? 0),
                    IdGrado: Number(gradeId ?? 0),
                    NroHoras: Number(gradeValues[gradeId] ?? 0)
                });
            });
        });
        payload.Celdas = celdas;

        if (selectedPlan) {
            await updatePlanCurricular(payload);
        } else {
            await handleSubmitRegistrar(payload);
        }
    };

    const handleSubmitRegistrar = async (payload) => {
        setIsSubmitting(true);
        let api = cuadroRequerimientosRegistrarPlanCurricularAPI();
        try {
            await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, successSubmitRegistrarActualizarCallback, true);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const successSubmitRegistrarActualizarCallback = async ({data}) => {
        refetchPlansCurricular();
    }

    const updatePlanCurricular = async (payload) => {
        setIsSubmitting(true);
        let api = cuadroRequerimientosEditarPlanCurricularAPI();
        try {
            await submitForm(Object.values(KEYS), api, payload, SECTION_NAME, successSubmitRegistrarActualizarCallback, true);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }

    };

    const handleDeletePlan = async (plan) => {
        await executeManagePostRequest(cuadroRequerimientosEliminarPlanCurricularAPI(plan.IdPlanCurricular), {}, (res) => {
            refetchPlansCurricular();
            resetFormTable();
        }, true, (err) => {
            console.log("error", err);
        }, true);
    };

    const refetchPlansCurricular = () => {
        executeManageGet(cuadroRequerimientosListarPlanesCurricularesAPI(), (res) => {
            setHidePlanCreate(res?.data?.PuedeCrear ?? false);
            const plansOrder = res?.data?.Items?.sort((a, b) => b.IdPlanCurricular - a.IdPlanCurricular) ?? [];
            setPlans(plansOrder);
            if (plansOrder?.length > 0) {
                refetchPlanToEdit(plansOrder[0]);
                setShowSaveInfo(false);
                setEditMode(false);
                clearAllInputValidationMessages(Object.values(KEYS), SECTION_NAME);
            } else {
                setEditMode(true);
                setShowSaveInfo(true);
            }
        }, false);
    };

    const refetchCombox = async () => {
        const responseCursos = executeManageGet(cuadroRequerimientosGetAllCursosAPI(), async (res) => {
            const cursos = await res?.data?.length > 0 ? await res.data.map((c) => ({
                value: c.Value,
                label: c.Text
            })).sort((a, b) => a.label.localeCompare(b.label)) : [];
            setCursos(cursos);
            setCursosCurrent(cursos);
        }, false);

        const responseLevels = executeManageGet(cuadroRequerimientosGetRelatedDataTypeWithDescripcionAPI(ID_TIPO_NIVEL_NIVEL), async (res) => {
            const levels = await res?.data?.length > 0 ? await res.data.map((n) => ({
                value: n.Value,
                label: n.Text
            })) : [];
            setNiveles(levels);
        }, false);

        await Promise.all([responseCursos, responseLevels]).then((res) => {
            refetchPlansCurricular();
        });
    };

    const handleChangeNivel = (e) => {
        setSelectedNivel(e?.target?.value ?? null);
        refetchGradesCurricular(e?.target?.value?.value ?? 0);
        setCursosCurrent(cursos);
        resetTable();
    };

    const resetFormTable = () => {
        setSelectedPlan(null);
        setFormName('');
        setSelectedNivel(null);
        resetTable();
    };

    const resetTable = () => {
        setGridValues({});
        setGrades([]);
        setSpecialties([]);
    };

    const colors = {
        'B': 'bg-orange',
        'BE': 'bg-orange',
        'PK': 'bg-orange',
        'K': 'bg-orange',
        '1': 'bg-blue',
        '2': 'bg-blue',
        '3': 'bg-blue',
        '4': 'bg-green',
        '5': 'bg-green',
        '6': 'bg-green',
        '7': 'bg-green',
        '8': 'bg-green',
        '9': 'bg-green',
        '10': 'bg-green',
        '11': 'bg-green',
    };
    const refetchGradesCurricular = (nivel) => {
        const api = cuadroRequerimientosGetRelatedDataTypeWithDescripcionAPI(nivel);
        executeManageGet(api, (res) => {
            const formatGrades = res?.data?.length > 0 ? res.data.map((n) => {
                return {
                    label: n.Text,
                    color: colors[n.Text],
                    value: n.Value
                }
            }) : [];
            setGrades(formatGrades);
        }, false);
    };

    const handleChangeCurso = (e) => {
        const course = e.target.value;
        setCursosCurrent(prev => prev.filter(c => c.value !== course.value));

        const exists = specialties.some(s => s.value === course.value);
        if (exists) {
            return;
        }

        const newRow = {};
        grades.forEach(g => {
            newRow[g.value] = '0';
        });

        setGridValues(prev => ({
            ...prev,
            [course.value]: newRow
        }));

        setSpecialties(prev => [...prev, course]);
    };

    const handleDeleteSpecialty = (specToDelete) => {
        setSpecialties(prev => prev.filter(s => s.value !== specToDelete.value));

        const curso = cursos.find(c => c.value == specToDelete.value);
        const cursosCurrentSort = [...cursosCurrent, curso].sort((a, b) => a.label.localeCompare(b.label));
        setCursosCurrent(cursosCurrentSort);

        setGridValues(prev => {
            const newState = { ...prev };
            delete newState[specToDelete.value];
            return newState;
        });
    };

    const handleGridChange = (specId, gradeId, newValue) => {
        setGridValues(prev => ({
            ...prev,
            [specId]: {
                ...prev[specId],
                [gradeId]: newValue
            }
        }));
    };

    const EditableCell = ({ value, onChange, isDisabled }) => {
        const handleChange = (e) => {
            const val = e.target.value;
            if (/^\d*$/.test(val)) {
                if (val.length > 1 && val.startsWith('0')) {
                    onChange(val.substring(1));
                } else {
                    onChange(val);
                }
            }
        };

        return (
            <input
                className="form-control"
                type="text"
                defaultValue={value}
                onChange={() => {}}
                onBlur={handleChange}
                onKeyDown={(e) => e.key === "Enter" && e.target.blur()}
                maxLength={2}
                disabled={isDisabled}
                style={{
                    width: '100%',
                    height: '100%',
                    minWidth: 0,
                    textAlign: 'center',
                    padding: 0,
                    margin: 0,
                    fontFamily: 'inherit',
                    fontSize: 'inherit',
                    color: 'inherit'
                }}
            />
        )

    };

    useEffect(() => {
        refetchCombox();
    }, []);

    return (
        <ModalForm
            titulo={title}
            width="1100px"
            showModal={showModal}
            hasSaveButton={false}
            contentPadding={"0"}
            >

            <Styles>
                <Row style={{ marginRight: '0', marginLeft: '0' }}>
                    <Col md={4} className="mb-4">
                        {
                            hidePlanCreate && (
                                <div className="d-flex justify-content-end mb-2 mt-2">
                                    <PrimaryActionButtonForModal onClick={handleNewPlan}>
                                        Nuevo
                                    </PrimaryActionButtonForModal>
                                </div>
                            )
                        }

                        <div className="sidebar-list">
                            <div className="list-item" style={{ backgroundColor: '#f1f1f1', fontWeight: 'bold', cursor: 'default' }}>
                                <div className='flex font-gothan-medium'>Plan Curricular</div>
                                <div className='flex font-gothan-medium'>Acciones</div>
                            </div>
                            {plans.length > 0 && plans.map(plan => (
                                <div
                                    key={`${uuidv4()}`}
                                    className={`list-item ${selectedPlan?.IdPlanCurricular === plan.IdPlanCurricular ? 'active' : ''}`}
                                >
                                    <Title onClick={() => handleSelectPlan(plan)}>{plan.Nombre}</Title>
                                    <div className="actions">
                                        {plan.PuedeEditar && (
                                            <FontAwesomeIcon icon={faEdit}   size="sm" className="action-icon" title="Editar" onClick={() => handleEditPlan(plan)} />
                                        )}
                                        {plan.PuedeEliminar && (
                                            <FontAwesomeIcon icon={faTrash}    size="sm" className="action-icon" title="Eliminar" onClick={() => handleDeletePlan(plan)} />
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>

                    <Col md={8} className='info-plan-curricular'>
                        <div className="p-3">
                            <Row>
                                <Col md={6}>
                                    <InputText
                                        placeholder={""}
                                        label="Nombre"
                                        value={formName}
                                        onChange={(e) => setFormName(e.target.value)}
                                        isRequired={true}
                                        direction="column"
                                        isDisabled={!editMode}
                                        sectionName={SECTION_NAME}
                                        name="Nombre"
                                    />
                                </Col>
                                <Col md={6}>
                                    <InputSelect
                                        label="Nivel"
                                        options={niveles}
                                        value={selectedNivel}
                                        onChange={handleChangeNivel}
                                        name="IdNivel"
                                        isRequired={true}
                                        direction="column"
                                        isDisabled={selectedNivel !== null || !editMode}
                                        sectionName={SECTION_NAME}
                                        placeholder={""}
                                    />
                                </Col>
                                <Col md={12}>
                                    <InputSelect
                                        label="Curso"
                                        options={cursosCurrent}
                                        onChange={handleChangeCurso}
                                        name="curso"
                                        isRequired={true}
                                        direction="column"
                                        isDisabled={!editMode || selectedNivel === null}
                                        sectionName={SECTION_NAME}
                                    />
                                </Col>
                            </Row>

                            <div className="table-container">
                                <Table bordered hover size="sm" className="custom-table">
                                    <thead className='listar-thead'>
                                    <tr>
                                        {grades.length > 0 && (
                                            <th rowSpan="2" style={{ width: '150px' }}>
                                                <div className='flex font-gothan-medium'>Cursos</div>
                                            </th>
                                        )}
                                        {grades.length > 0 && (
                                            grades.map((g, idx) => (
                                                <th key={idx} className={g.color} style={{ width: '25px' }}>
                                                    <div className='flex font-gothan-medium'>{g.label}</div>
                                                </th>
                                            ))
                                        )}
                                        {grades.length > 0 && (
                                            <th style={{ width: '60px' }}>
                                                <div className='flex font-gothan-medium'>Acciones</div>
                                            </th>
                                        )}
                                    </tr>
                                    </thead>
                                    <tbody className='listar-tbody'>
                                    {specialties.length > 0 && specialties.map((spec, rIdx) => (
                                        <tr key={rIdx}>
                                            <td className="text-left">{spec?.label ?? ''}</td>
                                            {grades.length > 0 && grades.map((g, cIdx) => (
                                                <td key={`${uuidv4()}`}>
                                                    <EditableCell
                                                        value={gridValues[spec.value]?.[g.value] || '0'}
                                                        onChange={(val) => handleGridChange(spec.value, g.value, val)}
                                                        isDisabled={!editMode}
                                                    />
                                                </td>
                                            ))}
                                            {specialties.length > 0 && <td>
                                                {editMode && (
                                                    <FontAwesomeIcon icon={faTrash} size="sm" className="action-icon" title="Eliminar" onClick={() => handleDeleteSpecialty(spec)} />
                                                )}
                                            </td>}
                                        </tr>
                                    ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </Col>
                    <Col md={12} className="mb-2 d-flex justify-content-between">
                        <div className="mt-3 text-danger small">
                            *Campos Obligatorios
                        </div>
                        <div className="d-flex justify-content-end mr-3">
                            {selectedNivel != null && editMode && (
                                <div className="modalContainer">
                                            <button
                                                 onClick={handleClearAll}
                                                 disabled={selectedNivel === null}
                                                 type="submit"
                                                 className={`btn btn-primary generic-button-ficha-modal mr-2`}
                                                >
                                       Borrar todo
                                    </button>
                                </div>
                            )}
                            {showSaveInfo && editMode && (
                                <div className="modalContainer">
                                    <button
                                        onClick={handleSavePlan}
                                        type="submit"
                                        className={`btn btn-primary generic-button-ficha-modal`}
                                    >
                                        Guardar
                                    </button>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
                {showConfirmModal && (
                    <ConfirmModalStyle>
                        <GenericModal
                            showModal={closeConfirmModal}
                            width="500px"
                            titulo="Atención"
                        >
                            <div className="modal-body pt-3 pb-3">
                                <div className="container-fluid text-center">
                                    Se borrará el avance de grados y reseteará el nivel, esta seguro?
                                </div>
                            </div>
                            <div className="modal-footer justify-content-center border-0 p-3">
                                <button
                                    className="btn btn-outline-primary generic-button-ficha-outlined mr-2"
                                    onClick={closeConfirmModal}>
                                    Cancelar
                                </button>
                                <div className="modalContainer">
                                    <button
                                        onClick={confirmClearAll}
                                        type="submit"
                                        className={`btn btn-primary generic-button-ficha-modal`}
                                    >
                                        Aceptar
                                    </button>
                                </div>
                            </div>
                        </GenericModal>
                    </ConfirmModalStyle>
                )}
            </Styles >
        </ModalForm>
    );
}

ConfigPlanCurricular.propTypes = {
    showModal: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired
}

export default ConfigPlanCurricular;